<template>
  <a-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :bodyStyle="bodyStyle"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    :footer="null"
    @cancel="close"
    :okButtonProps="{ props: {disabled: (disableSubmit)} }"
    cancelText="关闭">
    <a-form :form="form">
      <a-card title="转让方基本信息" :bordered="false">
        <a-row>
          <a-col :span="22">
            <a-col :span="5" class="labelTop" >
              <span>转让方名称：</span>
            </a-col>
            <a-col :span="17">
              <a-form-item class="itemInput">
                <a-input :readOnly="true" disabled v-model="transEn.legalName" />
              </a-form-item>
            </a-col>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-col :span="9" class="labelTop" >
              <span>转让方代码：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-input :readOnly="true" disabled v-model="transEn.legalCode" />
              </a-form-item>
            </a-col>
          </a-col>
          <a-col :span="12">
            <a-col :span="9" class="labelTop" >
              <span>转让方类别：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <j-dict-select-tag
                  dictCode="bidder_code_type"
                  :readOnly="true" disabled
                  v-model="transEn.bidderCodeType"
                />
              </a-form-item>
            </a-col>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-col :span="9" class="labelTop" >
              <span>转让方角色：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-input  :readOnly="true" disabled  v-model="transEn.roleName" />
              </a-form-item>
            </a-col>
          </a-col>
          <a-col :span="12">
            <a-col :span="9" class="labelTop" >
              <span>转让方行为批准单位：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-input :readOnly="disableSubmit" :disabled="disableSubmit" v-decorator="['transApprovalUnit', validatorRules.transApprovalUnit]"/>
              </a-form-item>
            </a-col>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-col :span="9" class="labelTop" >
              <span>转让比例：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-input-number  placeholder="请输入转让比例"  :max-length="500" :readOnly="disableSubmit" :disabled="disableSubmit" style="width: 80%"
                                 v-decorator="['transPre', validatorRules.transPre]" /> %

              </a-form-item>
            </a-col>
          </a-col>
          <a-col :span="12">
            <a-col :span="9" class="labelTop" >
              <span>管理层是否有收购意向：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-select v-decorator="['isManagerBuyWant', validatorRules.isManagerBuyWant]" placeholder="请选择" :disabled="disableSubmit ">
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="1">是</a-select-option>
                  <a-select-option value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-col>
        </a-row>
      </a-card>
      <a-card title="标的企业基本信息" :bordered="false">
        <a-row>
          <a-col :span="20">
            <a-col :span="5" class="labelTop" >
              <span>企业名称：</span>
            </a-col>
            <a-col :span="17">
              <a-form-item class="itemInput">
                <a-input :readOnly="disableSubmit" :disabled="disableSubmit"  v-decorator="['subjectEnterName', validatorRules.subjectEnterName]" />
              </a-form-item>
            </a-col>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-col :span="9" class="labelTop" >
              <span>所属行业：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <j-dict-select-tag :triggerChange="!disableSubmit" :readOnly="disableSubmit" :disabled="disableSubmit"
                                   placeholder="请选择所属行业" dictCode="pr_Industry" v-decorator="['subjectEnterIndustry', {}]"/>


              </a-form-item>
            </a-col>
          </a-col>
          <a-col :span="12">
            <a-col :span="9" class="labelTop" >
              <span>所在地区：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <j-area-linkage :readOnly="disableSubmit" :disabled="disableSubmit" type="cascader" v-decorator="['subjectEnterAreacode', validatorRules.subjectEnterAreacode]"/>
              </a-form-item>
            </a-col>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>企业类型：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <j-dict-select-tag
                  placeholder="请选择企业类型"
                  dictCode="en_property"
                  :triggerChange="true"
                  :readOnly="disableSubmit" :disabled="disableSubmit"
                  v-decorator="['subjectEnProperty',{}]"
                />
              </a-form-item>
            </a-col>
          </a-col>
          <a-col :span="12">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>企业代码：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-input :readOnly="disableSubmit" :disabled="disableSubmit" v-decorator="['subjectLegalCode', validatorRules.subjectLegalCode]" />
              </a-form-item>
            </a-col>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>法定代表人：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-input placeholder="请输入法定代表人"  style="width: 100%"   :readOnly="disableSubmit" :disabled="disableSubmit"
                                v-decorator="['subjectLegalName', validatorRules.subjectLegalName]" />
              </a-form-item>
            </a-col>
          </a-col>
          <a-col :span="12">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>职工人数：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-input-number placeholder="请输入职工人数"  style="width: 100%"   :readOnly="disableSubmit" :disabled="disableSubmit"
                         v-decorator="['subjectEnterPerNum', validatorRules.subjectEnterPerNum]" />
              </a-form-item>
            </a-col>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-col :span="4" class="labelTop" >
              <span><font color="red"> *</font>注册地：</span>
            </a-col>
            <a-col :span="20">
              <a-form-item class="itemInput">
                <a-textarea placeholder="请输入注册地"  style="width: 100%" :readOnly="disableSubmit" :disabled="disableSubmit" v-decorator="['subjectLegalUnitAddress', validatorRules.subjectLegalUnitAddress]" />
              </a-form-item>
            </a-col>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>联系人：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-input placeholder="请输入联系人"  :readOnly="disableSubmit" :disabled="disableSubmit"
                         v-decorator="['subjectLegalContact', validatorRules.subjectLegalContact]" />
              </a-form-item>
            </a-col>
          </a-col>
          <a-col :span="12">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>联系电话：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-input placeholder="请输入联系电话"  :readOnly="disableSubmit" :disabled="disableSubmit"
                         v-decorator="['subjectLegalContactPhone', validatorRules.subjectLegalContactPhone]" />
              </a-form-item>
            </a-col>
          </a-col>
        </a-row>
      </a-card>
    </a-form>
    <div class="ant-modal-footer">
      <div>
        <a-button :loading="confirmLoading"  class="ant-btn" @click="handleCancel"><span>上一步</span></a-button>
        <a-button :loading="confirmLoading"  type="primary" class="ant-btn ant-btn-primary" @click="handleOk"><span>下一步</span></a-button>
        <a-button class="ant-btn" @click="close"><span>取消</span></a-button>
      </div>
    </div>

  </a-modal>
</template>

<script>
import Vue from "vue";
import {ACCESS_TOKEN} from "@/store/mutation-types";
import moment from "moment/moment";
import {downloadFile, getAction, postAction} from "@api/manage";
import {FzisListMixin} from "@/mixins/FzisListMixin";
import ProjectLandAddLandModal from "@views/earthmine/modules/ProjectLandAddLandModal.vue";
import pick from "lodash.pick";

export default {
  name: "SubjectStep4Modal",
  components: {ProjectLandAddLandModal},
  mixins:[FzisListMixin],
  data () {
    return {
      tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
      title: "操作",
      bodyStyle:{
        padding: "0",
        overflow:"auto",
        // height:(window.innerHeight-100)+"px"
        height:"550px"
      },
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      id:"",
      model:{},
      form: this.$form.createForm(this),
      url: {
        addOrUpdate: "/ebid-ce/propertyright/prSubjectTransfer/addOrUpdate"
      },
      modal:{},
      transEn:{},
    }
  },
  computed: {
    validatorRules: function() {
      return {
        transApprovalUnit: {rules: [{required: true, message: '请输入转让行为批准单位'}]},
        transPre: {rules: [{required: true, message: '请输入转让比例'}]},
        isManagerBuyWant: {rules: [{required: true, message: '请选择管理层是否有收购意向'}]},
        subjectEnterName: {rules: [{required: false, message: '请输入企业名称'}]},
        subjectEnterAreacode: {rules: [{required: true, message: '请选择地区'}]},
        subjectLegalName: {rules: [{required: true, message: '请输入法定代表人'}]},
        subjectLegalUnitAddress: {rules: [{required: false, message: '请输入注册地'}]},
        subjectLegalContact: {rules: [{required: false, message: '请输入联系人'}]},
        subjectLegalContactPhone: {rules: [{required: false, message: '请输入联系电话'}]},
        subjectLegalCode: {rules: [{required: false, message: '请输入企业代码'}]},
        subjectEnterPerNum: {rules: [{required: false, message: '请输入职工人数'}]},
      }
    },
    uploadAction() {
      return window._CONFIG['domianURL'] + '/ebid-ce/file/onlyUpload'
    },
  },
  methods:{
    close () {
      this.visible = false;
      this.$emit('close');

    },
    handleCancel () {
      this.visible = false;
      this.model.disableSubmit=this.disableSubmit;
      this.$emit('beforeStep','3',this.model);
    },
    //编辑
    edit(record)
    {
      this.visible = true;
      this.model=record;
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.id=this.model.id;
      this.getTranEnt();
      let that=this;
      console.log("this.model4",this.model)
      let fieldsVal = pick(this.model,'transApprovalUnit','transPre', 'isManagerBuyWant', 'subjectEnterName','subjectEnterIndustry','subjectEnterAreacode',
        'subjectEnProperty', 'subjectLegalCode', 'subjectLegalName','subjectEnterPerNum','subjectLegalUnitAddress','subjectLegalContact','subjectLegalContactPhone');
      this.$nextTick(() => {
        that.form.setFieldsValue(fieldsVal);
      });
    },
    //获取转让方企业信息
    getTranEnt()
    {///
      let enterpriseId;
      if(this.model.transEnterpriseId && this.model.transEnterpriseId!==null)
      {
        console.log("111",enterpriseId)
        enterpriseId=this.model.transEnterpriseId;
      }else {
        enterpriseId=this.$store.getters.userInfo.enterpriseId
      }
      console.log("111",enterpriseId)
      getAction('/ebid-ce/tmEnterprise/getEnterpriseById/'+enterpriseId).then(res => {
        if (res.success) {
          this.transEn=res.result;
          this.transEn.roleName="出让人";
          this.$forceUpdate();
        }
      })

    },
    //保存
    handleOk(){
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          let formData = Object.assign(that.modal, values);
          formData.id=that.id;
          formData.transEnterpriseName=that.transEn.legalName;
          formData.transEnterpriseId=that.transEn.id;
          //保存
          console.log("formData",formData);
          if(that.disableSubmit)
          {
            console.log("555dis",this.modal)
            that.modal.disableSubmit=this.disableSubmit;
            that.$emit('nextStep','5',that.modal);
            return;
          }
          that.confirmLoading=true;
          postAction(that.url.addOrUpdate,formData).then(res => {
            if (res.success) {
              that.$emit('nextStep','5',that.modal);
              that.$emit('loadData');
              return;
            }
            else
            {
              that.$message.error(res.message);
            }
          }).finally(() => {
            that.confirmLoading=false;
          });
        }
      })
    },
  }
}
</script>

<style scoped>
.labelTop{
  margin-top: 10px;
  text-align: right;
  color:#262626;
}
</style>